
import React, { Component } from "react";
import {
    Modal,
    ModalBody,
    ModalHeader,
    Button
} from "reactstrap";
import { StripeProvider, Elements } from "react-stripe-elements";

import Variables from "../../../Utils/Variables";
import Registry from "../../../Utils/Registry";

import EnterprisePaymentsBaseForm from "../../Enterprise/Payments/BaseForm";
import TYSelect from "../../TYSelect";


class CreateOrderFormPayment extends Component{
    constructor(props){
        super(props);

        this.loadMethods = this.loadMethods.bind(this);
        this.renderPaymentMethod = this.renderPaymentMethod.bind(this);
        this.selectPaymentMethod = this.selectPaymentMethod.bind(this);
        this.validateStep = this.validateStep.bind(this);
        this.togglePaymentMethodForm = this.togglePaymentMethodForm.bind(this);
        this.onCardAdded = this.onCardAdded.bind(this);

        this.api = Registry.registered("api");

        if(this.props.state)
            this.state = this.props.state;
        else{
            this.state = {
                loadingPayments: false,
                selected_method: null,
                payments_methods: [],
                add_method_modal_open: false
            };
        }
    }

    componentDidMount(){
        this.loadMethods();
    }

    loadMethods(){
        this.setState({loadingPayments: true});

        let methods = [];

        this.api.get("/business/paymentMethods")
            .then(results => {
                if(results && results.hasOwnProperty("data")){
                    if(results && results.hasOwnProperty("data")){
                        for(let c of results.data){
                            let card_lbl = "**** " + (c.object === 'card' ? c.last4 : (c.sepa_debit ? c.sepa_debit.last4 : c.last4));
                            if(c.object === 'card' && c.metadata.name)
                                card_lbl = c.metadata.name + " - " + card_lbl;
                            else if(c.metadata.name)
                                card_lbl = c.metadata.name + " - " + card_lbl;
                            methods.push({id: c.id, label: card_lbl, type: (c.object === "card" ? 1 : 2)});
                        }
                    }
                }

                this.setState({ payments_methods: methods, loadingPayments: false });
            })
            .catch(error => { this.setState({loadingPayments: false}); });
    }

    togglePaymentMethodForm(){
        this.setState({ add_method_modal_open: !this.state.add_method_modal_open });
    }

    selectPaymentMethod(item){
        this.setState({
            selected_method: item
        }, () => { this.props.onPaymentSelected(item); });
    }

    renderPaymentMethod(item){
        let icon = "";

        if(item.type === 1) // Card type
            icon = <i className="icon icon-credit-card" aria-hidden="true" />;
        else if(item.type === 2) // SEPA transfert type
            icon = <i className="icon icon-currency-eur" aria-hidden="true" />;

        return (
            <table>
                <tbody>
                <tr>
                    <td className="_w-30 center">{ icon }</td>
                    <td>{ item.label }</td>
                </tr>
                </tbody>
            </table>
        );
    }

    onCardAdded(){
        this.togglePaymentMethodForm();
        this.loadMethods();
    }

    validateStep(){
        if(this.state.selected_method)
            this.props.onValidateStep(this.state.selected_method, this.state);
    }

    render(){
        return (
            <div className="blue_dark">
                <h2 className="ty-subtitle">
                    Choisir le moyen de paiement
                </h2>

                <div className="ty-block">
                    {
                        this.state.loadingPayments ?
                            <div className="center">
                                <i className="icon icon-loading animated spin infinite f-20"> </i>
                            </div>
                            :
                            <TYSelect
                                items={this.state.payments_methods}
                                selected={this.state.selected_method}
                                renderItem={this.renderPaymentMethod}
                                itemClicked={this.selectPaymentMethod}
                                isSelected={(selected, item) => {return selected && selected.id===item.id}}
                            />
                    }

                    <div className="border-l-4-orange orange f-13 pad-l-10 marg-t-10">
                        Vous ne serez d&eacute;bit&eacute; qu'apr&egrave;s la livraison, en fonction
                        de la quantit&eacute; de carburant qui vous a &eacute;t&eacute; livr&eacute;e.
                    </div>

                    <div className="marg-t-15 right">
                        <div className="blue text-underline pointer" onClick={this.togglePaymentMethodForm}>Ajouter un moyen de paiement</div>
                    </div>
                </div>

                <div className="center marg-t-20">
                    <Button
                        className="text-uppercase"
                        color="primary"
                        disabled={!this.state.selected_method}
                        onClick={this.validateStep}
                    >
                        Valider
                    </Button>
                </div>

                {
                    this.state.add_method_modal_open ?
                        <Modal size="lg" isOpen={this.state.add_method_modal_open} toggle={this.togglePaymentMethodForm}>
                            <ModalHeader toggle={this.togglePaymentMethodForm}>Ajouter un moyen de paiement</ModalHeader>
                            <ModalBody>
                                <StripeProvider apiKey={Variables.stripe_token}>
                                    <Elements>
                                        <EnterprisePaymentsBaseForm
                                            newPaymentMethodAdded={this.onCardAdded}
                                            tyBlock={false}
                                            showTitle={false}
                                        />
                                    </Elements>
                                </StripeProvider>
                            </ModalBody>
                        </Modal>
                        :
                        ""
                }
            </div>
        );
    }
}

CreateOrderFormPayment.defaultProps = {
    onValidateStep: (payment, state) => {},
    onPaymentSelected: payment => {},
    selected_method: false,
    state: false
};

export default CreateOrderFormPayment;



// WEBPACK FOOTER //
// ./src/components/CreateOrder/Form/Payments.js